import { render, staticRenderFns } from "./Single-Product.vue?vue&type=template&id=e13734d6&"
import script from "./Single-Product.vue?vue&type=script&lang=js&"
export * from "./Single-Product.vue?vue&type=script&lang=js&"
import style0 from "./Single-Product.vue?vue&type=style&index=0&id=e13734d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports